import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../store';

export interface LoadingState {
    isLoading: boolean;
    activeRequests: any[];
}

const initialState: LoadingState = {
    isLoading: false,
    activeRequests: []
};

const loadingSlice = createSlice({
    name: 'loading',
    initialState,
    reducers: {
        startLoading(state, action: PayloadAction<string>) {
            state.activeRequests.push(action.payload);
            state.isLoading = true;
        },
        stopLoading(state, action: PayloadAction<string>) {
            state.activeRequests = state.activeRequests.filter(
                (requestId) => requestId !== action.payload
            );
            state.isLoading = state.activeRequests.length > 0;
        },
    },
});

export const { startLoading, stopLoading } = loadingSlice.actions;

export const selectIsLoading = (state: RootState) => state.loading.isLoading;

export default loadingSlice.reducer;
